module.exports = __webpack_public_path__ + "90b81c2bfd3137d98ae5dbf7741b7892.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-fr.html
// module id = 932
// module chunks = 0